import cn from 'classnames';

import toastProviderStyles from '@shared/providers/ToastProvider/ToastProvider.module.scss';

export function ToastCloseButton() {
  return <i className={cn('pi pi-times', toastProviderStyles.closeButton)}></i>;
}
